import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const ControlLevelSelect = ({ allowClear = true,
  disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { text: t('fields.productControlledStatus.uncontrolled'), value: '0' },
        { text: t('fields.productControlledStatus.controlled'), value: '1' },
        { text: t('fields.productControlledStatus.undefinedOption'), value: '2' }
      ] }
    />
  );
};
export default ControlLevelSelect;
